import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=a4520ff0&scoped=true&"
import script from "./MobileHeader.vue?vue&type=script&lang=js&"
export * from "./MobileHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=a4520ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4520ff0",
  null
  
)

export default component.exports